var React = require('react');

function LogoPlayWithoutCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M34.9386 24.1241L20.3553 14.7491C20.0358 14.5406 19.6229 14.5294 19.2933 14.7104C18.9575 14.8935 18.75 15.2435 18.75 15.625V34.375C18.75 34.7564 18.9575 35.1064 19.2933 35.2895C19.4479 35.374 19.6208 35.4167 19.7917 35.4167C19.987 35.4167 20.1844 35.3617 20.3553 35.2509L34.9386 25.8759C35.2356 25.6847 35.4167 25.354 35.4167 25C35.4167 24.646 35.2356 24.3154 34.9386 24.1241ZM20.8333 32.4666V17.5334L32.4483 25L20.8333 32.4666Z","fill":"#1a1a1a"}));
}

LogoPlayWithoutCircle.defaultProps = {"fill":"none","viewBox":"18.75 14.58 16.67 20.83"};

module.exports = LogoPlayWithoutCircle;

LogoPlayWithoutCircle.default = LogoPlayWithoutCircle;
